// Environment configuration
export const environment = {
  // Firebase Configuration
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'demo-key',
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'ima-onboard.firebaseapp.com',
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'ima-onboard',
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'ima-onboard.appspot.com',
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '123456789',
    appId: import.meta.env.VITE_FIREBASE_APP_ID || 'demo-app',
  },
  
  // Emulator Configuration
  emulators: {
    auth: '127.0.0.1:9099',
    firestore: '127.0.0.1:8080',
    storage: '127.0.0.1:9199',
    functions: '127.0.0.1:5001',
  },
  
  // Environment Detection - More explicit
  isDevelopment: import.meta.env.DEV === true || import.meta.env.MODE === 'development',
  isLocalhost: typeof window !== 'undefined' && (
    window.location.hostname === 'localhost' || 
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '0.0.0.0'
  ),
  
  // Computed
  get useEmulators() {
    // Force emulator mode for localhost
    return this.isLocalhost;
  },
  
  get isProduction() {
    return !this.useEmulators;
  }
};
